<template>
  <div v-if="obj">
    <van-popup v-model="visible" :close-on-click-overlay="false" position="top">
      <van-sticky offset-top="0">
        <div class="title" @click="close">
          <i class="el-icon-back C2" />
          {{ obj.DispName }}
          <span v-if="sGetConfig('chkCarHide0Price') && obj.Price1 == 0"></span>
          <span v-else> ${{ obj.Price1 }}</span>
        </div>
      </van-sticky>

      <div class="main">
        <!-- <pre>{{ obj }}</pre> -->
        <!-- {{ gCheckItemcData(obj) }} -->

        <!-- 上限: {{ sGetConfig("maxQty") }}
        已選: {{ gSum(ordertmp, "Qty") }}
        -{{ beforeQty }} +{{ obj.Qty }} -->
        <!-- 隱藏S1標籤{{ sGetConfig("chkHideS1GroupLabel") }} -->

        <van-image :src="obj.ImgFile" lazy-load width="200" @click="preview = true" :show-error="false" />
        <van-image-preview v-model="preview" :images="[obj.ImgFile]" :showIndex="false" />
        <div class="remark" v-html="gNl2br(gGetIcon(obj.Remark))" />
        <div v-if="gGetDcText(obj)">
          <span class="tag">{{ gGetDcText(obj) }}</span>
        </div>
        <!-- {{ obj.rno }} -->

        <!-- GROUPS -->
        <!-- {{ gCheckS1Data(obj) }} -->

        <ItemGroups :groups="obj.Groups" @click="showDetailGroup" />
        <!-- <UserNote :itemnote="itemnote" v-if="sGetConfig('userNote')" /> -->
        <Stepper :item="obj" :doAmt="sumItemAmt().doAmt" v-if="!sConfig.noStepper.value" :maxQty="s1MaxQty" />
        <div style="text-align: center" v-if="sGetConfig('chkCheckItemMaxQty')">
          <!-- <van-tag size="large">已選{{ getMaxQty() }}</van-tag> -->
          <!-- <van-tag size="large">可選{{ getMaxQty() }}</van-tag> -->

          <van-tag size="large" plain>{{ getQtyTip() }}</van-tag>
        </div>
        <!-- {{ ordertmp }}
        {{ rst }} -->
        <!-- {{ $store.state.sConfig }}
        {{ $store.state.sConfig }} -->
        <Footer v-if="obj.rno" :b1="getBtnText()" @b1c="finish()" b0="刪除餐點" @b0c="cmdDelete()" :anime="anime" />
        <Footer v-else :b1="getBtnText()" @b1c="finish()" :anime="anime" />
      </div>
      <FrmItemDetailGroup ref="rItemDetailGroup" />
    </van-popup>
  </div>
</template>

<style scoped>
.remark {
  margin: 0.3rem 0 0.3rem 0;
  line-height: 1.6rem;
}

.title {
  background-color: rgba(255, 255, 255, 0.95);
  font-size: 1.6rem;
  padding: 1rem;
  z-index: 999;
}

.van-popup {
  width: 100%;
  height: 100%;
}

.main {
  padding: 1rem;
  padding-top: 0;
}
</style>

<script>
// import UserNote from "./Child/UserNote.vue";
var fits = require("../../../mixin/lib-fits-front");
export default {
  components: {
    // UserNote,
  },
  data() {
    return {
      visible: false,
      obj: null,
      preview: false,
      itemnote: "",
      anime: false,
      ordertmp: [],
      rst: [],
      beforeQty: 0,
      s1MaxQty: 0,
    };
  },
  methods: {
    checkMaxQty() {
      var maxQty = Number(this.sConfig.maxQty.value);
      var qty = this.gSum(this.ordertmp, "Qty");
      qty -= fits.val(this.beforeQty);
      qty += fits.val(this.obj.Qty);
      // console.log("checkMaxQty", maxQty, qty);
      if (qty > maxQty) {
        this.gMsgbox("數量上限:" + maxQty + "，請刪除部分品項~");
        return false;
      }
      return true;
    },
    getMaxQty() {
      let maxItemQty = this.sGetConfig("maxItemQty"); // 加入購物車的數量上限
      // {{ sGetConfig("selRoundLimit") }}
      let onlyOneList = this.sGetConfig("selRoundLimit");
      if (Array.isArray(onlyOneList)) {

        let find = onlyOneList.find(r => r == this.obj.ItemName);
        console.log("find", find);
        if (find) maxItemQty = 1;
      }

      let checked = this.sGetConfig("chkCheckItemMaxQty"); // 勾選檢查購物車數量(必免多選)
      if (!checked) return maxItemQty;

      let sumQty = Number(this.sumItemQty());

      // if (this.obj.rno != undefined) sumQty += this.obj.Qty;

      let maxQty = maxItemQty - sumQty; // 扣除已選的數量
      maxQty += this.beforeQty;

      return fits.val(maxQty);
    },
    getQtyTip() {
      // let maxItemQty = this.sGetConfig("maxItemQty"); // 加入購物車的數量上限
      let checked = this.sGetConfig("chkCheckItemMaxQty");
      let maxQty = this.getMaxQty();
      // let sumQty = this.sumItemQty();
      // let diffQty = maxQty - sumQty;
      if (!checked) return "";

      let line = "可選擇" + maxQty + "份";
      // line += "上限:" + maxItemQty;
      // line += ", 已選:" + sumQty;
      // line += ", 可選:" + maxQty;

      return line;
    },
    sumItemQty() {
      if (!this.obj) return 0;
      let array = this.ordertmp.filter((r) => r.ItemName == this.obj.ItemName);
      return fits.sum(array, "Qty");
    },
    async finish() {
      try {
        if (this.obj.OpenCode == "Y")
          return this.gMsgbox("時價項目，請洽服務人員");

        if (this.obj.Qty > this.getMaxQty())
          return this.gMsgbox(this.getQtyTip(), "超過可點數量");

        if (this.gOverSendTime())
          return this.gMsgbox(this.sGetConfig("txtOverMaxOrderTimeText"));

        if (!this.checkData()) {
          this.gMsgbox("請確認附餐必選項目", "Side Check");
          return;
        }

        if (!this.checkMaxQty()) return;

        this.obj.Groups.map((g) => {
          //如果userNote為空字串，將數量歸0
          g.options.map((o) => {
            // console.log("o.ItemName", o.ItemName, o);
            if (o.ItemName == "餐點備註:") o.Qty = 0;
            if (o.ItemName == ":") o.Qty = 0;
          });
        });

        this.gShowLoading();
        var body = { item: this.obj };
        if (this.obj.rno == undefined) {
          await this.apiAddItem(body);
          this.gMsg("加入:" + this.obj.ItemName + "x" + this.obj.Qty);
        } else {
          await this.apiUpdItem(body);
          this.gMsg("更新:" + this.obj.ItemName + "x" + this.obj.Qty);
        }

        this.$emit("callback", this.obj);
        this.close();
        this.gClearLoading();
      } catch (error) {
        console.log(error);
      }
    },
    checkItemMaxQty() {
      let checked = this.sGetConfig("chkCheckItemMaxQty");
      if (!checked) return true;

      return false;
    },
    showDetailGroup(obj) {
      this.$refs.rItemDetailGroup.show(obj);
    },

    onChangePriceCap(priceCap) {
      // console.log("onChangePriceCap", JSON.stringify(priceCap));
      this.obj.Price1 = priceCap.Price;
    },
    appendUserNote() {
      let row = {
        id: "userNote",
        text: "",
        type: "AN",
        limit: "0",
        min: "0",
        max: "0",
        lock: true,
        num: false,
        remark: "",
        options: [
          {
            TypeNo: 4,
            ItemNo: 1,
            ItemName: "",
            ItemType: "-",
            Price1: 0,
            Price2: 0,
            Price3: 0,
            KPtype: this.obj.KPtype,
            OpenCode: "N",
            ImgFile: "",
            ItemCode: "",
            AvailTime: "",
            CtrlFlag: "",
            Price1Cap: "",
            Price2Cap: "",
            Price3Cap: "",
            DispName: "",
            Groups: [],
            Qty: 0,
            DefaultQty: 0,
          },
        ],
        key: fits.uuid(),
      };
      // this.obj.Groups.push(row);
      this.obj.Groups.splice(0, 0, row);
      // console.log("obj", JSON.stringify(this.obj));
    },
    async show(obj) {
      try {
        let res = await this.apiGetOrdertmp();
        this.ordertmp = res.data.objs;
        this.rst = res.data.rst;

        // if (!this.checkMaxQty()) return;

        if (obj.rno) {
          this.obj = obj;
          this.beforeQty = obj.Qty;
          this.s1MaxQty = this.getMaxQty();
          return (this.visible = true);
        }
        this.gShowLoading();
        var query = { typeno: obj.TypeNo, itemname: obj.ItemName };
        res = await this.apiGetItemC(query);
        this.obj = res.data;
        if (this.obj.StockQty <= 0)
          return this.gMsgbox("此項目今日已無可售數量", "Sold Out");

        if (this.sGetConfig("userNote")) this.appendUserNote(this.obj);
        // console.log(JSON.stringify(this.obj));
        this.s1MaxQty = this.getMaxQty();
        if (this.s1MaxQty == 0) return this.gMsgbox("此項已點滿，請選擇其它餐點");
        this.visible = true;
        this.gClearLoading();
      } catch (error) {
        console.log(error);
        this.gClearLoading();
      } finally {
        this.gClearLoading();
      }
    },
    close() {
      this.obj = null;
      this.visible = false;
    },
    // getBtnText() {
    //   this.anime = this.checkData();

    //   if (this.obj.rno) {
    //     return "更新餐點 Update";
    //   }

    //   return "加入" + this.obj.Qty + "份  $" + this.sumItemAmt() + " Add";
    //   // return "加入" +;
    // },
    getBtnText() {
      if (this.obj.OpenCode == "Y") return "時價項目，請洽服務人員"
      if (!this.checkData()) {
        this.anime = false;
        return "請選擇附餐 Side Check";
      }

      this.anime = true;
      if (this.obj.rno) {
        return "更新餐點";
      }

      if (this.sGetConfig("chkCartNoSumAmt"))
        return "加入" + this.obj.Qty + "份  " + " Add " + this.obj.Qty;

      return (
        "加入" + this.obj.Qty + "份  $" + this.sumItemAmt().amt + " Add " + this.obj.Qty
      );
    },
    sumItemAmt() {
      var obj = this.obj;
      var rst = this.gGetItemcRst(obj);
      // console.log("sumItemAmt", rst[0].Qty, obj.Discount);
      if (rst.length == 0) {
        return 0;
      }
      var s1Qty = rst[0].Qty;
      // console.log("s1Qty", s1Qty);
      rst[0].Qty = 1;
      // console.log("s1", s1Qty);
      rst.map((r) => (r.Amt = r.Price1 * r.Qty));
      var sum = this.gSum(rst, "Amt");
      var doAmt = this.gCalcDcAmt(s1Qty, sum, obj.Discount);
      var original = sum * s1Qty;
      var amt = original + doAmt;
      return { original: original, doAmt: doAmt, amt: amt };
    },
    async cmdDelete() {
      try {
        this.gMsgbox(
          "刪除:" + this.obj.ItemName + "x" + this.obj.Qty,
          "刪除 Remove"
        ).then(async () => {
          this.gShowLoading();
          this.obj.Qty = 0;
          var body = { item: this.obj };
          await this.apiUpdItem(body);
          this.$emit("callback");
          this.close();
          this.gClearLoading();
        });
      } catch (error) {
        console.log(error);
        this.gClearLoading();
      }
    },
    checkData() {
      var checked = this.gCheckS1Data(this.obj);
      if (!checked) {
        return false;
      }
      return true;
    },
  },
};
</script>
